import { PageNotFound } from '@shared/PageNotFound/PageNotFound'
import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import { AccessLevel, useAccessLevel } from './hooks/useAccessLevel'
import { APP_TYPE } from './types/User'
import { APP_STORAGE_KEY } from './util'
import { NotificationAlerts } from './views'
import { ScheduledCommunicationTemplates } from './views/ScheduledCommunicationTemplate'
import { ScheduledCommunicationTypes } from './views/ScheduledCommunicationType/ScheduledCommunicationTypes/ScheduledCommunicationTypes'

export const CommunicationsRouter = () => {
  const { HUB_MANAGER } = AccessLevel
  const { accessGranted } = useAccessLevel()
  const active_app = localStorage.getItem(APP_STORAGE_KEY)

  if (active_app !== APP_TYPE.COMMUNICATIONS) return null
  return (
    <Routes>
      {accessGranted([HUB_MANAGER]) && (
        <Route element={<Navigate replace={true} to="/scheduled-communication-types" />} path="/" />
      )}
      {accessGranted([HUB_MANAGER]) && (
        <Route element={<ScheduledCommunicationTypes />} path="/scheduled-communication-types" />
      )}
      {accessGranted([HUB_MANAGER]) && (
        <Route element={<ScheduledCommunicationTemplates />} path="/scheduled-communication-templates" />
      )}
      <Route element={<NotificationAlerts />} path="/notifications" />
      <Route element={<PageNotFound />} path="*" />
    </Routes>
  )
}
